import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-recharge-search-form',
  templateUrl: './recharge-search-form.component.html',
  styleUrls: ['./recharge-search-form.component.scss']
})
export class RechargeSearchFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
